import React from 'react'
import { useGlobalOverlay } from '../../context/GlobalOverlayContext'

const GlobalOverlay = () => {
  const { overlayItems, positions } = useGlobalOverlay()

  return (
    <div
      style={{ position: 'fixed', pointerEvents: 'none', width: 0, height: 0 }}
    >
      {Object.keys(overlayItems).map((key) => {
        const { element } = overlayItems[key]
        const style = positions[key] || { position: 'fixed' }

        return (
          <div
            key={key}
            style={{
              ...style,
              pointerEvents: 'auto', // Allow interaction with the overlay content
            }}
          >
            {element}
          </div>
        )
      })}
    </div>
  )
}

export default GlobalOverlay
